<table id="keypad" class="mb-2 w-100">
    @for (row of keys; track row) {
        <tr class="keyboard">
            @for (key of row; track key) {
                <td [attr.rowspan]="key[0] == 'Ok' ? 2 : null">
                    <button type="button" class="btn btn-light" id="{{ 'key-' + key[0] }}" (mousedown)="pressed($event, key)">
                        @if (key[0] != 'Bksp') {
                            <p>{{ key[0] }}</p>
                        } @else {
                            <p class="theme-delete"></p>
                        }
                    </button>
                </td>
            }
        </tr>
    }
</table>
